// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1718":"34af7a8ef4f52b8f","5376":"ca7442d3f2825164"}[chunkId] + ".css";
};